<template>
  <div>
    <header id="page-topbar">
      <div class="navbar-header">
        <div class="d-flex align-self-stretch">
          <!-- LOGO -->
          <div class="navbar-brand-box" style="position: relative; display: flex; align-items: center; height: 100%;">
            <router-link tag="a" to="/" class="logo logo-dark" style="display: flex; align-items: center; line-height: normal;">
              <span class="logo-sm">
                <img src="@/assets/images/logo-icon.png" alt="Eventfy" style="height: 32px; display: block;" />
              </span>
              <span class="logo-lg">
                <img v-if="isDarkMode" src="@/assets/images/logo-light.png" alt="Eventfy" style="height: 32px; display: block;" />
                <img v-else src="@/assets/images/logo-auth.png" alt="Eventfy" style="height: 32px; display: block;" />
              </span>
            </router-link>

            <!-- Collapse toggle button (desktop only) -->
            <button
              class="sidebar-collapse-btn d-none d-lg-flex"
              @click="toggleMenu"
            >
              <i
                class="pi"
                :class="isCollapsed ? 'pi-chevron-right' : 'pi-chevron-left'"
                style="font-size: 12px; color: #6b7280;"
              ></i>
            </button>
          </div>

          <!-- Mobile hamburger -->
          <button
            type="button"
            class="mobile-hamburger d-lg-none"
            @click="toggleMobileMenu"
          >
            <i
              :class="isMobileMenuOpen ? 'bx bx-x' : 'bx bx-menu'"
              :style="{ fontSize: isMobileMenuOpen ? '26px' : '22px', color: '#374151' }"
            ></i>
          </button>

          <!-- Nome do evento (desktop) -->
          <div v-if="setting && setting.name" class="d-none d-lg-flex" style="align-items: center; align-self: center; gap: 8px; margin-left: 24px;">
            <div class="navbar-event-badge" style="width: 28px; height: 28px; background-color: #eff6ff; border-radius: 6px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
              <span style="font-size: 11px; font-weight: 600; color: #2563eb;">{{ eventInitials }}</span>
            </div>
            <span class="navbar-event-name" style="font-size: 13px; font-weight: 600; color: #111827; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ setting.name }}</span>
          </div>

        </div>

        <div class="d-flex align-items-center" style="gap: 10px;">

          <!-- Dark Mode Toggle -->
          <button
            class="theme-toggle-btn"
            @click="toggleTheme"
            :title="isDarkMode ? 'Modo claro' : 'Modo escuro'"
          >
            <i :class="isDarkMode ? 'bx bx-sun' : 'bx bx-moon'" style="font-size: 18px;"></i>
          </button>

          <!-- Meu Painel -->
          <a
            :href="masterPanelUrl"
            class="my-panel-btn d-none d-sm-flex"
          >
            <div class="dm-panel-icon" style="width: 30px; height: 30px; background-color: #f3f4f6; border-radius: 6px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
              <i class="pi pi-th-large" style="font-size: 14px; color: #6b7280;"></i>
            </div>
            <span style="font-size: 13px; font-weight: 500; color: #374151; white-space: nowrap;">Meu painel</span>
          </a>

          <b-dropdown right variant="white" toggle-class="user-menu-btn" no-caret menu-class="user-menu-dropdown">
            <template v-slot:button-content>
              <div style="display: flex; align-items: center; gap: 8px;">
                <div style="width: 30px; height: 30px; background-color: #2563eb; border-radius: 6px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                  <span style="color: #fff; font-size: 12px; font-weight: 600;">{{ userInitials }}</span>
                </div>
                <span class="d-none d-sm-block dm-user-name" style="font-size: 13px; font-weight: 500; color: #374151; max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ user.name }}</span>
                <i class="pi pi-chevron-down d-none d-sm-inline dm-user-chevron" style="font-size: 12px; color: #9ca3af;"></i>
              </div>
            </template>
            <!-- User info header -->
            <div class="dm-dropdown-header" style="padding: 12px 16px; border-bottom: 1px solid #e5e7eb;">
              <div style="display: flex; align-items: center; gap: 12px;">
                <div style="width: 40px; height: 40px; background-color: #2563eb; border-radius: 6px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                  <span style="color: #fff; font-size: 14px; font-weight: 600;">{{ userInitials }}</span>
                </div>
                <div style="min-width: 0;">
                  <p class="dm-dropdown-name" style="font-size: 14px; font-weight: 600; color: #111827; margin: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ user.name }}</p>
                  <p class="dm-dropdown-email" style="font-size: 12px; color: #6b7280; margin: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ user.email }}</p>
                </div>
              </div>
            </div>
            <!-- Logout button -->
            <div style="padding: 8px 12px;">
              <button
                @click="logout()"
                style="width: 100%; display: flex; align-items: center; justify-content: center; padding: 8px 12px; font-size: 14px; color: #fff; background-color: #3b82f6; border: none; border-radius: 6px; cursor: pointer;"
                class="user-menu-logout-btn"
              >
                <span style="margin-right: 8px;">Sair</span>
                <i class="pi pi-sign-out" style="font-size: 12px;"></i>
              </button>
            </div>
          </b-dropdown>
        </div>
      </div>
    </header>

    <!-- Mobile Menu Overlay -->
    <transition name="mobile-fade">
      <div v-if="isMobileMenuOpen" class="mobile-overlay" @click="closeMobileMenu"></div>
    </transition>

    <!-- Mobile Menu Panel -->
    <transition name="mobile-slide">
      <div v-if="isMobileMenuOpen" class="mobile-menu">
        <!-- Event info header -->
        <div v-if="setting && setting.name" class="mobile-menu-event">
          <div class="mobile-menu-event-avatar">
            <span>{{ eventInitials }}</span>
          </div>
          <span class="mobile-menu-event-name">{{ setting.name }}</span>
        </div>

        <!-- Navigation -->
        <nav class="mobile-menu-nav">
          <template v-for="item in filteredMenuItems">
            <!-- Section title -->
            <div v-if="item.isTitle" :key="'mt-'+item.id" class="mobile-menu-title">
              {{ $t(item.label) }}
            </div>

            <!-- Item with sub-items -->
            <div v-else-if="hasSubItems(item)" :key="'mi-'+item.id" class="mobile-menu-group">
              <a href="javascript:void(0);" class="mobile-menu-item" @click="toggleSubMenu(item.id)">
                <i :class="item.icon" class="mobile-menu-icon"></i>
                <span>{{ $t(item.label) }}</span>
                <i class="bx bx-chevron-down mobile-menu-arrow" :class="{ 'is-open': openSubMenus.includes(item.id) }"></i>
              </a>
              <div class="mobile-sub-menu" :class="{ 'is-open': openSubMenus.includes(item.id) }">
                <template v-for="subitem in item.subItems">
                  <router-link
                    v-if="hasMenuPerm(subitem)"
                    :to="subitem.link"
                    :key="'ms-'+subitem.id"
                    class="mobile-sub-menu-item"
                    @click.native="closeMobileMenu"
                  >
                    {{ $t(subitem.label) }}
                  </router-link>
                </template>
              </div>
            </div>

            <!-- Simple link item -->
            <router-link
              v-else
              :to="item.link"
              :key="'ml-'+item.id"
              class="mobile-menu-item"
              @click.native="closeMobileMenu"
            >
              <i :class="item.icon" class="mobile-menu-icon"></i>
              <span>{{ $t(item.label) }}</span>
            </router-link>
          </template>
        </nav>

        <!-- Footer -->
        <div class="mobile-menu-footer">
          <a :href="masterPanelUrl" class="mobile-menu-item mobile-menu-back">
            <i class="pi pi-th-large mobile-menu-icon"></i>
            <span>Meu Painel</span>
            <i class="pi pi-external-link" style="margin-left: auto; font-size: 12px; color: #9ca3af;"></i>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import i18n from '../i18n'
import { mapState, mapActions, mapGetters } from 'vuex'
import { menuItems } from './menu'
import { getTheme, setTheme } from '@/modules/auth/storage'

/**
 * Nav-bar Component
 */
export default {
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      languages: [
        {
          flag: require('@/assets/images/flags/br.jpg'),
          language: 'br',
          title: 'Português'
        }
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      menuItems: menuItems,
      isMobileMenuOpen: false,
      openSubMenus: [],
      currentTheme: getTheme()
    }
  },
  components: { },
  mounted () {
    this.applyTheme(this.currentTheme)
    this.value = this.languages.find((x) => x.language === i18n.locale)
    this.text = this.value.title
    this.flag = this.value.flag
    this.$store.dispatch('settingEvent/LoadOnceSetting')
    // Load RSVP settings for mobile menu permission checks
    if (!this.settingRSVP || Object.keys(this.settingRSVP).length === 0) {
      this.$store.dispatch('settingRSVP/GetRSVP').catch(() => {})
    }
  },
  beforeDestroy () {
    document.body.style.overflow = ''
  },
  watch: {
    '$route' () {
      this.closeMobileMenu()
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settingEvent', ['setting']),
    ...mapState('settingRSVP', ['settingRSVP']),
    ...mapGetters('auth', ['hasPermission', 'isSuperAdmin']),
    userInitials () {
      if (!this.user || !this.user.name) return 'U'
      const names = this.user.name.split(' ')
      return names.length > 1
        ? (names[0][0] + names[names.length - 1][0]).toUpperCase()
        : names[0][0].toUpperCase()
    },
    eventInitials () {
      if (!this.setting || !this.setting.name) return 'EV'
      const words = this.setting.name.split(' ').filter(w => w.length > 0)
      return words.length > 1
        ? (words[0][0] + words[1][0]).toUpperCase()
        : words[0].substring(0, 2).toUpperCase()
    },
    isDarkMode () {
      return this.currentTheme === 'dark'
    },
    masterPanelUrl () {
      return localStorage.getItem('sso_return_url') || process.env.VUE_APP_MASTER_PANEL_URL || '/'
    },
    filteredMenuItems () {
      return this.menuItems.filter(item => this.hasMenuPerm(item))
    }
  },
  methods: {
    ...mapActions('auth', {
      logoutUser: 'ActionSignOut'
    }),
    toggleTheme () {
      this.currentTheme = this.currentTheme === 'dark' ? 'light' : 'dark'
      this.applyTheme(this.currentTheme)
      setTheme(this.currentTheme)
      this.$root.$emit('theme-changed', this.currentTheme)
    },
    applyTheme (theme) {
      if (theme === 'dark') {
        document.documentElement.classList.add('dark-mode')
      } else {
        document.documentElement.classList.remove('dark-mode')
      }
    },
    toggleMenu () {
      this.$parent.toggleMenu()
    },
    toggleMobileMenu () {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      if (this.isMobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
        this.openSubMenus = []
      }
    },
    closeMobileMenu () {
      if (!this.isMobileMenuOpen) return
      this.isMobileMenuOpen = false
      document.body.style.overflow = ''
      this.openSubMenus = []
    },
    toggleSubMenu (id) {
      const index = this.openSubMenus.indexOf(id)
      if (index > -1) {
        this.openSubMenus.splice(index, 1)
      } else {
        this.openSubMenus.push(id)
      }
    },
    hasSubItems (item) {
      return item.subItems !== undefined && item.subItems.length > 0
    },
    hasMenuPerm (item) {
      if (item.requiresPayment) {
        const hasPayment = this.settingRSVP &&
          (this.settingRSVP.has_payment === true ||
           this.settingRSVP.has_payment === 1 ||
           this.settingRSVP.has_payment === '1')
        if (!hasPayment) return false
      }
      if (!item.perm || item.perm === null) return true
      if (this.isSuperAdmin) return true
      return this.hasPermission(item.perm)
    },
    initFullScreen () {
      document.body.classList.toggle('fullscreen-enable')
      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen()
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen()
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          )
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    },
    setLanguage (locale, country, flag) {
      this.lan = locale
      this.text = country
      this.flag = flag
      i18n.locale = locale
    },
    logout () {
      const returnUrl = localStorage.getItem('sso_return_url')
      const isSso = localStorage.getItem('sso_origin') === 'master_panel'

      this.logoutUser().then(() => {
        // Limpar flags SSO
        localStorage.removeItem('sso_return_url')
        localStorage.removeItem('sso_origin')

        if (isSso && returnUrl) {
          window.location.href = returnUrl
        } else {
          this.$router.push({ name: 'login' })
        }
      })
    }
  }
}
</script>

<!-- Unscoped styles for user menu dropdown and transitions -->
<style>
.user-menu-btn {
  display: flex !important;
  align-items: center !important;
  padding: 0 10px !important;
  height: 40px !important;
  background-color: #f9fafb !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  font-size: 13px !important;
  line-height: 1.25rem !important;
  transition: background-color 0.15s ease !important;
}

.user-menu-btn:hover,
.user-menu-btn:focus {
  background-color: #f3f4f6 !important;
}

.user-menu-dropdown {
  min-width: 14rem !important;
  padding: 0 !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden;
}

.user-menu-logout-btn:hover {
  background-color: #2563eb !important;
}

.my-panel-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  height: 40px;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.25rem;
  text-decoration: none;
  transition: background-color 0.15s ease;
}

.my-panel-btn:hover {
  background-color: #f3f4f6;
  text-decoration: none;
  color: #374151;
}

/* ===== Dark Mode Toggle ===== */
.theme-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  color: #6b7280;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.theme-toggle-btn:hover {
  background-color: #f3f4f6;
  color: #374151;
}

html.dark-mode .theme-toggle-btn {
  background-color: rgba(245, 158, 11, 0.1);
  border-color: rgba(245, 158, 11, 0.2);
  color: #F59E0B;
}

html.dark-mode .theme-toggle-btn:hover {
  background-color: rgba(245, 158, 11, 0.18);
  border-color: rgba(245, 158, 11, 0.35);
  color: #FBBF24;
}

/* ===== Mobile Menu Transitions ===== */
.mobile-fade-enter-active {
  transition: opacity 0.25s ease;
}
.mobile-fade-leave-active {
  transition: opacity 0.2s ease;
}
.mobile-fade-enter,
.mobile-fade-leave-to {
  opacity: 0;
}

.mobile-slide-enter-active {
  transition: transform 0.25s ease-out, opacity 0.25s ease-out;
}
.mobile-slide-leave-active {
  transition: transform 0.2s ease-in, opacity 0.2s ease-in;
}
.mobile-slide-enter,
.mobile-slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* ===== Mobile Menu Styles ===== */
.mobile-hamburger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-left: 4px;
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  align-self: center;
}

.mobile-hamburger:hover {
  background-color: #f3f4f6;
}

.mobile-overlay {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.mobile-menu {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mobile-menu-event {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px 12px 20px;
  border-bottom: 1px solid #f3f4f6;
  flex-shrink: 0;
}

.mobile-menu-event-avatar {
  width: 36px;
  height: 36px;
  background-color: #eff6ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mobile-menu-event-avatar span {
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
}

.mobile-menu-event-name {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-menu-nav {
  flex: 1;
  padding: 8px 12px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mobile-menu-title {
  padding: 16px 12px 6px 12px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #9ca3af;
  font-weight: 600;
}

.mobile-menu-title:first-child {
  padding-top: 4px;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  padding: 12px;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  margin-bottom: 2px;
  text-decoration: none;
  transition: background-color 0.15s ease;
  cursor: pointer;
}

.mobile-menu-item:hover {
  background-color: #f9fafb;
  text-decoration: none;
  color: #374151;
}

.mobile-menu-item:active {
  background-color: #f3f4f6;
}

.mobile-menu-item.router-link-active,
.mobile-menu-item.router-link-exact-active {
  background-color: #eff6ff;
  color: #2563eb;
}

.mobile-menu-item.router-link-active .mobile-menu-icon,
.mobile-menu-item.router-link-exact-active .mobile-menu-icon {
  color: #2563eb;
}

.mobile-menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-width: 24px;
  font-size: 18px;
  color: #6b7280;
  margin-right: 12px;
  transition: color 0.15s ease;
}

.mobile-menu-arrow {
  margin-left: auto;
  font-size: 18px;
  color: #9ca3af;
  transition: transform 0.25s ease;
}

.mobile-menu-arrow.is-open {
  transform: rotate(180deg);
}

.mobile-sub-menu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  padding-left: 12px;
}

.mobile-sub-menu.is-open {
  max-height: 800px;
}

.mobile-sub-menu-item {
  display: block;
  padding: 10px 12px 10px 36px;
  color: #6b7280;
  font-size: 13px;
  font-weight: 400;
  border-radius: 8px;
  text-decoration: none;
  margin-bottom: 1px;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.mobile-sub-menu-item:hover {
  background-color: #f9fafb;
  color: #374151;
  text-decoration: none;
}

.mobile-sub-menu-item:active {
  background-color: #f3f4f6;
}

.mobile-sub-menu-item.router-link-active,
.mobile-sub-menu-item.router-link-exact-active {
  background-color: #eff6ff;
  color: #2563eb;
}

.mobile-menu-footer {
  padding: 8px 12px;
  border-top: 1px solid #f3f4f6;
  flex-shrink: 0;
}

.mobile-menu-back {
  color: #2563eb !important;
}

.mobile-menu-back .mobile-menu-icon {
  color: #2563eb;
}

/* Hide mobile-only elements on desktop */
@media (min-width: 992px) {
  .mobile-overlay,
  .mobile-menu,
  .mobile-hamburger {
    display: none !important;
  }
}
</style>

<!-- Scoped styles -->
<style scoped>
.sidebar-collapse-btn {
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  position: absolute;
  right: -12px;
  top: 20px;
  z-index: 10;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  padding: 0;
}

.sidebar-collapse-btn:hover {
  background: #f9fafb;
}
</style>
